import * as React from 'react'
import {Box, Typography} from '@mui/material'
import {alertStripSx} from '../../../../styles/patterns'
import {FONT, SIZE, WEIGHT} from '../../../../styles/foundation/typography'
import {INFO} from '../../../../styles/foundation/colors'
import {GAP} from '../../../../styles/foundation/spacing'
import {packOf} from './logic'
import {REVIEW_INTRO} from './copy'
import EmptyState from '../components/EmptyState'
import RqReviewCard from './RqReviewCard'

/**
 * Weight Freeze (v2) — Requests: the under-review tab.
 *
 * A card list, not a table — see RqReviewCard's own header for why. This
 * component owns none of the mutation: `onSubmit(req, payload)` is passed
 * straight through from each card up to RequestsSection, which is the only
 * place that talks to the shared store.
 */
export default function RqReview({rows, packs, onSubmit, onAcceptProposal, onDeclineProposal, onNavigate, focusFallbackRef}) {
  if (rows.length === 0) {
    return (
      <EmptyState
        title='Nothing under review'
        body='No weight freeze request is with Prozo at the moment, or none matches the current search and filter.'
      />
    )
  }

  return (
    <Box sx={{display: 'grid', gap: GAP.md}}>
      <Box sx={{...alertStripSx(INFO), alignItems: 'flex-start'}}>
        <Typography sx={{fontFamily: FONT, fontSize: SIZE['2xs'], lineHeight: 1.6, fontWeight: WEIGHT.regular}}>
          {REVIEW_INTRO}
        </Typography>
      </Box>

      {rows.map((r) => (
        <RqReviewCard
          key={r.id}
          req={r}
          pack={packOf(packs, r.packId)}
          onSubmit={onSubmit}
          onAcceptProposal={onAcceptProposal}
          onDeclineProposal={onDeclineProposal}
          onNavigate={onNavigate}
          focusFallbackRef={focusFallbackRef}
        />
      ))}
    </Box>
  )
}
